import { BaseModel } from '@/models/base.model';

export class TermsOfUseModel extends BaseModel {
    constructor(public config?: string,
                public description?: string,
                public value?: { pt: string, en: string }) {
        super();
    }
}
